/** As "Últimas vezes" agrupadas pela clínica do grupo, como o SISAC mostra. */

import type { UltimasVezesDoPaciente } from '@cliqcrm/contracts';

type Vez = UltimasVezesDoPaciente['vezes'][number];

const SEM_VALOR = '—';

/** "10/09/2026 10:00", sem passar por fuso: a hora é a da clínica. */
export function dataHoraNaTela(dataHora: string | null): string {
  const m = dataHora?.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
  if (!m) return SEM_VALOR;
  return m[4] ? `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}` : `${m[3]}/${m[2]}/${m[1]}`;
}

/**
 * Um grupo por clínica, na ordem em que a clínica aparece pela primeira vez
 * (os atendimentos já vêm do mais novo ao mais antigo).
 */
export function gruposDasVezes(
  vezes: readonly Vez[],
): { titulo: string; linhas: Record<string, string>[] }[] {
  const grupos = new Map<string, Record<string, string>[]>();
  for (const vez of vezes) {
    const titulo = vez.clinica ? `Clínica: ${vez.clinica}` : 'Clínica não informada';
    const linhas = grupos.get(titulo) ?? [];
    linhas.push({
      data_hora: dataHoraNaTela(vez.data_hora),
      situacao: vez.situacao ?? SEM_VALOR,
      movimento: vez.movimento ?? SEM_VALOR,
      tipo: vez.tipo ?? SEM_VALOR,
      medico: vez.medico ?? SEM_VALOR,
      procedimentos: vez.procedimentos ?? SEM_VALOR,
      convenio: vez.convenio ?? SEM_VALOR,
      plano: vez.plano ?? SEM_VALOR,
      local_origem: vez.local_origem ?? SEM_VALOR,
    });
    grupos.set(titulo, linhas);
  }
  return [...grupos.entries()].map(([titulo, linhas]) => ({ titulo, linhas }));
}
